import React, { useEffect, useState, Fragment } from "react";
import Spinner from "./components/Spinner";
import SoundBoard from "./tabs/soundboard/SoundBoard";
import Upload from "./tabs/Upload";
import Commands from "./tabs/Commands";
import Delete from "./tabs/Delete";
import Status from "./tabs/Status";
import Shitposting from "./tabs/Shitposting";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { BossFight } from "./bossfight/BossFight";
import { BossFightButton } from "./bossfight/BossFightButton";
import ErrorCatcher from "./components/Error";
import { Youtube2Mp3 } from "./tabs/Youtube2Mp3";

const enableBossFight = false;

function App() {
  const [activeTab, setActiveTab] = useState<string>(
    localStorage.getItem("heg-soundboard-activeTab") ?? "soundboard"
  );
  const [bossFight, setBossFight] = useState(false);

  useEffect(() => {
    localStorage.setItem("heg-soundboard-activeTab", activeTab);
  }, [activeTab]);

  const tabs = {
    status: () => activeTab === "status",
    commands: () => activeTab === "commands",
    soundboard: () => activeTab === "soundboard",
    upload: () => activeTab === "upload",
    delete: () => activeTab === "delete",
    shitposting: () => activeTab === "shitposting",
    youtube: () => activeTab === "youtube",
  };

  if (bossFight && enableBossFight) {
    return <BossFight exitBossFight={() => setBossFight(false)} />;
  }

  return (
    <div className="App">
      <div className="top-right">
        <Spinner scale={0.2} className="spinnerDiv" />
      </div>
      <header className="App-header">
        <h1>HegBot</h1>
        <button
          type="button"
          onClick={() => {
            setActiveTab("status");
          }}
          style={{ width: "20ch" }}
          className={tabs.status() ? "activeTab" : undefined}
        >
          Status
        </button>
        <button
          type="button"
          onClick={() => {
            setActiveTab("commands");
          }}
          style={{ width: "20ch" }}
          className={tabs.commands() ? "activeTab" : undefined}
        >
          Commands
        </button>
        <button
          type="button"
          onClick={() => {
            setActiveTab("soundboard");
          }}
          style={{ width: "20ch" }}
          className={tabs.soundboard() ? "activeTab" : undefined}
        >
          Soundboard
        </button>
        <button
          type="button"
          onClick={() => {
            setActiveTab("upload");
          }}
          style={{ width: "20ch" }}
          className={tabs.upload() ? "activeTab" : undefined}
        >
          Upload Sound
        </button>
        <button
          type="button"
          onClick={() => {
            setActiveTab("delete");
          }}
          style={{ width: "20ch" }}
          className={tabs.delete() ? "activeTab" : undefined}
        >
          Delete Sound
        </button>
        <button
          type="button"
          onClick={() => {
            setActiveTab("youtube");
          }}
          style={{ width: "20ch" }}
          className={tabs.youtube() ? "activeTab" : undefined}
          // disabled
        >
          Youtube To MP3
        </button>
        <button
          type="button"
          // onClick={() => {setActiveTab("shitposting")}}
          style={{ width: "20ch" }}
          className={tabs.shitposting() ? "activeTab" : undefined}
          disabled
        >
          Shitposting
        </button>
      </header>
      <hr />
      <Fragment>
        <ErrorCatcher>
          {tabs.soundboard() && <SoundBoard />}
          {tabs.upload() && <Upload />}
          {tabs.commands() && <Commands />}
          {tabs.delete() && <Delete />}
          {tabs.status() && <Status />}
          {tabs.shitposting() && <Shitposting />}
          {tabs.youtube() && <Youtube2Mp3 />}
        </ErrorCatcher>
        {enableBossFight && <BossFightButton setBossFight={setBossFight} />}
      </Fragment>
    </div>
  );
}

export default App;
